import { IconButton, Slider } from "@mui/material";
import styled from "styled-components";

export const CropContainer = styled.div`
  position: relative;
  top: -26px;
  width: 232px;
  height: 232px;
  background: #f5f5f5;
  clip-path: inset(0% round 30px);
  overflow: hidden;

  &:hover .move-btn {
    display: none;
  }
`;

export const MoveBtn = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-around;
  background-color: #bcbcbc;
  position: absolute;
  height: 24px;
  width: 62px;
  top: 190px;
  left: 90px;
  border-radius: 34px;
  color: black;
  font-size: 15px;
  padding: 5px;
  opacity: 0.6;
  transition: 0.2s ease-in-out;

  svg {
    height: 15px;
    width: 15px;
  }
`;

export const ControlContainer = styled.div`
  position: absolute;
  bottom: 66px;
  width: 75%;
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 5px;
`;

export const GappedContainer = styled.div`
  display: flex;
  gap: 0.5rem;
  align-items: center;
`;

export const ControlIcon = styled.span`
  cursor: pointer;
  color: black;
  opacity: 0.58;

  &:hover {
    opacity: 1;
  }
`;

export const ControlIconButton = styled(IconButton)`
  && {
    outline: none;
    height: fit-content;
    padding: 3px;
  }
`;

export const CropSlider = styled(Slider)`
  && {
    color: black;
  }
`;

export const ZoomSlider = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
`;

export const LabelText = styled.div`
  display: flex;
  gap: 5px;
  align-items: center;
  justify-content: center;

  svg {
    height: 16px;
    width: 16px;
  }

  p {
    font-size: 15px;
    color: black;
  }
`;
